import { useMapContext } from "@luciad/ria-sample-common/hooks/useMapContext";
import { useToastContext } from "@luciad/ria-sample-common/hooks/useToast";
// import { OGCAPIMapsCapabilities } from "@luciad/ria/model/capabilities/OGCAPIMapsCapabilities";
// import { OGCAPIMapsCapabilitiesLayer } from "@luciad/ria/model/capabilities/OGCAPIMapsCapabilitiesLayer";
import { getReference } from "@luciad/ria/reference/ReferenceProvider";
import React, { ChangeEvent, useState } from "react";
import { ConnectToURLPage } from "../components/ConnectToURLPage";
import { WizardPreviousNextButtons } from "../components/WizardPreviousNextButtons";
import { addLayer } from "../DataFormatsUtil";
import { useWizard } from "../hooks/useWizard";
import { OGCAPIMapsCapabilities } from "./OGCAPIMapsCapabilities";
import { OGCAPIMapsCapabilitiesLayer } from "./OGCAPIMapsCapabilitiesLayer";
import { OGCAPIMapsDataLoader } from "./OGCAPIMapsDataLoader";

const webMercatorReference = getReference("EPSG:3857");

interface Props {
  onPrevious: () => void;
  onReset: () => void;
}

type WMSWizardPageKey = "enterUrl" | "loading" | "selectLayers";

export const ConnectToOGCAPIMapsWizard = ({ onPrevious, onReset }: Props) => {
  const { currentPageKey, previousPageKey, changePage, resetWizard } = useWizard<WMSWizardPageKey>("enterUrl", onReset);
  const [capabilities, setCapabilities] = useState<OGCAPIMapsCapabilities | null>(null);

  const { map } = useMapContext();
  const { showErrorToast } = useToastContext();

  const handleURLSubmit = (url: string) => {
    // console.log(url);
    changePage("loading");

    // WMSDataLoader.createLayer

    // fetch(url += "?f=json")
    //   .then(res => res.json())
    //   .then(out => {
    //     console.log('Checkout this JSON! ', out);
    //     setCapabilities(capabilities);
    //     changePage("selectLayers");
    //   })
    //   .catch(error => { 
    //     changePage("enterUrl");
    //     showErrorToast("Could not connect with the OGC API Maps server", error);
    //   });

    OGCAPIMapsCapabilities.fromURL(url).then(capabilities => {
      setCapabilities(capabilities);
      changePage("selectLayers");
    }).catch(error => {
      changePage("enterUrl");
      showErrorToast("Could not connect with the WMS server", error);
    });
  }

  const handleWMSLayerSelect = (selectedLayers: SelectedWMSLayer[]) => {
    if (capabilities) {
      try {
        selectedLayers.forEach(selectedLayer => {
          const layer = OGCAPIMapsDataLoader.createLayer(selectedLayer.layer);
          addLayer(map, layer).catch(error => {
            showErrorToast("Could not add OGC API Maps layer", error);
          });
        });
      } catch (error) {
        console.log("Could not create OGC API Maps layer", error);
        // showErrorToast("Could not create WMS layer", error);
      } finally {
        resetWizard();
      }
    }
  }

  switch (currentPageKey) {
    case "enterUrl": {
      // return <ConnectToURLPage defaultValue="https://test.cubewerx.com/cubewerx/cubeserv/demo/ogcapi/Daraa/collections"
      return <ConnectToURLPage defaultValue="https://maps.gnosis.earth/ogcapi/collections"
        onSubmit={handleURLSubmit}
        onPrevious={onPrevious}
      />;
    }
    case "loading": {
      return <h1>Loading WMS capabilities...</h1>;
    }
    case "selectLayers": {
      return <SelectWMSLayers capabilities={capabilities!}
        onSelect={handleWMSLayerSelect}
        onPrevious={() => changePage(previousPageKey)} />
    }
  }
}

// const flattenWMSLayers = (layers: OGCAPIMapsCapabilitiesLayer[]): OGCAPIMapsCapabilitiesLayer[] => {
//   let result: OGCAPIMapsCapabilitiesLayer[] = [];
//   for (const layer of layers) {
//     if (layer.name) {
//       result.push(layer);
//     }
//     result = result.concat(layer.children);
//   }
//   return result;
// }

interface SelectedWMSLayer {
  layer: OGCAPIMapsCapabilitiesLayer;
  // style: string;
}

interface SelectWMSLayersProps {
  capabilities: OGCAPIMapsCapabilities;
  onSelect: (layers: SelectedWMSLayer[]) => void;
  onPrevious: () => void;
}

interface OGCAPIMapsLayerItem {
  layer: OGCAPIMapsCapabilitiesLayer;
  selected: boolean;
  // selectedStyle: string;
}

const SelectWMSLayers = ({ capabilities, onSelect, onPrevious }: SelectWMSLayersProps) => {
  const layers = capabilities.layers;
  // const layers = flattenWMSLayers(capabilities.layers);
  const [items, setItems] = useState<OGCAPIMapsLayerItem[]>(layers.map(layer => {
    return {
      layer,
      selected: false,
      // selectedStyle: layer.styles[0]?.name ?? "Default style"
    }
  }));

  
  const toggleVector = (ev: ChangeEvent<HTMLInputElement>) => {
    const selected = ev.target.checked;
    capabilities.useVectorTiles(selected);
  }

  const handleLayerSelectedChange = (ev: ChangeEvent<HTMLInputElement>, item: OGCAPIMapsLayerItem) => {
    const selected = ev.target.checked;
    setItems(items => items.map(i => {
      if (i === item) {
        return { ...i, selected };
      }
      return i;
    }));
  }

  const handleStyleSelectionChange = (ev: ChangeEvent<HTMLSelectElement>, item: OGCAPIMapsLayerItem) => {
    const selectedStyle = ev.target.value;
    setItems(items => items.map(i => {
      if (i === item) {
        return { ...i, selectedStyle };
      }
      return i;
    }));
  }

  const handleSelect = () => {
    const selectedItems = items.filter(i => i.selected).map(i => {
      return {
        layer: i.layer,
        // style: i.selectedStyle
      }
    });
    onSelect(selectedItems);
  }

  return (
    <>
      <div>
        {items.map((item) => {
          const { name, title, styles } = item.layer;
          const showStylesSelect = styles.length >= 2;

          return (
            <div key={name}>
              <input type="checkbox" onChange={(ev) => handleLayerSelectedChange(ev, item)} />
              {title}
              {/* {showStylesSelect && <select value={item.selectedStyle} onChange={ev => handleStyleSelectionChange(ev, item)}>
                {styles.map(style => <option value={style.name}>{style.name}</option>)}
              </select>} */}
            </div>
          )
        })}
      </div>
      {/* < input type="checkbox" onChange={(ev) => toggleVector(ev)} /> */}
      <WizardPreviousNextButtons onPrevious={onPrevious} onNext={handleSelect} />
    </>
  )

}

